import { SET_ROOM_TYPES } from '../reducers/roomTypes';

export const acSetRoomTypes = (roomTypes) => ({
  type: SET_ROOM_TYPES,
  payload: roomTypes,
});
